import { ApiProperty } from "@nestjs/swagger";

export class PlantRequest{
    @ApiProperty()
    plantId : number;
    plantName:string;
    zoneId?:number;


      constructor(plantId : number,plantName?:string,zoneId?:number){
        this.plantId = plantId;
        this.plantName= plantName;
        this.zoneId= zoneId;
    }

}